import { tv } from 'tailwind-variants';

const styles = tv({
    base: "",
    variants: {
        display: {
            none: "iris:hidden",
            inline: "iris:inline",
            "inline-block": "iris:inline-block",
            block: "iris:block",
            contents: "iris:contents",
        },
    },
});

export { styles as default };
